/* ============================================================================
   RDG — DATES DE LA FRISE DE LIVRAISON
   Refonte DA 2026-08 · fin du lot 5 · cree le 21/08/2026

   Calcule les deux dates de blocks/pr-delivery-timeline.liquid en jours
   OUVRES a partir d'aujourd'hui. Les delais viennent du bloc lui-meme, via
   des attributs de donnees : ils sont donc reglables depuis l'editeur de
   theme sans toucher a ce fichier.

   POURQUOI EN JAVASCRIPT ET NON EN LIQUID
   Liquid est rendu au moment ou Shopify met la page en cache. Une date
   calculee en Liquid serait figee a la date de mise en cache, pas a celle de
   la visite — et resterait fausse pendant des jours. Le calcul doit se faire
   chez la visiteuse.

   POURQUOI UN ASSET ET NON UN <script> EN LIGNE
   Ce fichier ne depend d'aucune variable Liquid, donc il est mis en cache une
   fois pour toutes. Dans sa version precedente il etait echappe dans une
   chaine JSON du gabarit et repartait a chaque chargement de fiche produit.
   ========================================================================== */

(function () {
  'use strict';

  /* Jours ouvres : on saute samedi et dimanche. Les jours feries ne sont pas
     traites — il en faudrait la liste par pays, et se tromper de ferie ferait
     plus de degats qu'un jour d'ecart. */
  function ajouterJoursOuvres(depart, jours) {
    var d = new Date(depart.getTime());
    var ajoutes = 0;
    while (ajoutes < jours) {
      d.setDate(d.getDate() + 1);
      var jour = d.getDay();
      if (jour !== 0 && jour !== 6) ajoutes++;
    }
    return d;
  }

  function majuscule(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* La langue vient du document et non d'une constante : le site a une
     version anglaise, ou « Mer. 3 sept. » n'aurait aucun sens. */
  function langue() {
    return document.documentElement.lang || 'fr-FR';
  }

  function formatCourt(d) {
    return majuscule(d.toLocaleDateString(langue(), {
      weekday: 'short', day: 'numeric', month: 'short'
    }));
  }

  function formatLong(d) {
    return majuscule(d.toLocaleDateString(langue(), {
      weekday: 'short', day: 'numeric', month: 'long'
    }));
  }

  function poser(racine) {
    var blocs = (racine || document).querySelectorAll('[data-rdg-delivery-estimate]');
    if (!blocs.length) return;

    var aujourdhui = new Date();

    Array.prototype.forEach.call(blocs, function (bloc) {
      var dExp = parseInt(bloc.getAttribute('data-expedition'), 10);
      var dLiv = parseInt(bloc.getAttribute('data-livraison'), 10);
      if (isNaN(dExp)) dExp = 1;
      if (isNaN(dLiv)) dLiv = 3;
      /* Garde-fou : une livraison annoncee AVANT l'expedition se lirait comme
         une erreur de la boutique. On repousse plutot que d'afficher l'absurde. */
      if (dLiv < dExp) dLiv = dExp;

      var expedition = ajouterJoursOuvres(aujourdhui, dExp);
      var livraison = ajouterJoursOuvres(aujourdhui, dLiv);

      var elExp = bloc.querySelector('[data-rdg-dt-ship]');
      var elLiv = bloc.querySelector('[data-rdg-dt-delivery]');
      if (elExp) elExp.textContent = formatCourt(expedition);
      if (elLiv) elLiv.textContent = formatLong(livraison);
    });
  }

  if (document.readyState !== 'loading') poser();
  else document.addEventListener('DOMContentLoaded', function () { poser(); });

  /* L'editeur de theme re-rend sections et blocs sans recharger la page. */
  document.addEventListener('shopify:section:load', function (e) { poser(e.target); });
  document.addEventListener('shopify:block:select', function (e) { poser(e.target); });
})();
